import moment from "moment";
import { JobCategoryTypes } from "../Models/job";

export const parseJsonString = (jsonString: string): any => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};

export function formateDateInYMDFormat(dateValue: any) {
  if (dateValue) {
    const splitDate = dateValue?.toString('dd/MM/yyyy')?.split('/');
    const modifiedDate = (splitDate?.length) ? (splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]) : null;
    return modifiedDate ? new Date(modifiedDate) : null;
  } else {
    return null;
  }
}

export function getFormattedDateWithTimeZone(date: any): string | null {
  if (!date) return null;

  // If already ISO string in UTC format — return as-is
  if (typeof date === "string" && (date.endsWith("Z") || date.includes("T"))) {
    return date;
  }

  // If Moment instance
  if (moment.isMoment(date)) {
    const year = date.year();
    const month = date.month();
    const day = date.date();
    return new Date(Date.UTC(year, month, day)).toISOString();
  }

  // If plain JS Date or a date string
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return null;

  // Normalize to UTC start-of-day
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString();
}

export function getNormalizedName(name: string | undefined | null): string | null {
  if (!name) return null;

  return name?.replace(/\s+/g, ' ')?.trim();
}

export function getNormalizedMultilineText(text: string | undefined | null): string | null {
  if (!text || !text?.trim()) return null;
  // collapse multiple spaces // replace tabs with space // collapse multiple blank lines into one line
  const normalizedText = text?.replace(/ {2,}/g, ' ')?.replace(/\t+/g, ' ')?.replace(/\n{2,}/g, '\n')?.trim();

  return normalizedText;
}

export function getNormalizedFullName(...names: (string | undefined | null)[]): string {
  const fullName = names
    .map(name => getNormalizedName(name))
    .filter(Boolean)
    .join(' ');

  return fullName || null;
}

export function hasJobCategory(categoryValue: number = 0, flag: JobCategoryTypes): boolean {
  return (categoryValue & flag) !== 0;
}

export function matchesAllRequiredCategories(jobCategory: number = 0, requiredFlags: number): boolean {
  return (jobCategory & requiredFlags) === requiredFlags;
}

export function normalizeTagId(tag: any): string {
  const rawId = tag?.tagId ?? tag?.id ?? tag?.value;
  return rawId === undefined || rawId === null ? '' : String(rawId).trim();
}

export function getSelectedTagIdSet(selectedTags: any[]): Set<string> {
  return new Set(
    (selectedTags || [])
      .map(tag => normalizeTagId(tag))
      .filter(id => id !== '')
  );
}

export function sortTagsToTop(tagListforClient: any[], selectedClientTags: any[]): void {
  if (!tagListforClient || !tagListforClient.length) {
    return;
  }

  const selectedTagIds = getSelectedTagIdSet(selectedClientTags);

  tagListforClient.sort((a, b) => {
    const aSelected = selectedTagIds.has(normalizeTagId(a));
    const bSelected = selectedTagIds.has(normalizeTagId(b));

    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;

    const aName = (a?.tagname || '').toString();
    const bName = (b?.tagname || '').toString();
    return aName.localeCompare(bName);
  });
}
export function canShowEditDeleteContainer(data: any): boolean {
  return !data?.isFinalOrStandardInvoice
    && !data?.isClosedWipControlPeriod
    && (data?.logTimeId ?? 0) > 0
    && !data?.editStatus
    && !data?.isWIPLocked;
}
